import React from 'react';

type Props = {
    spacing?: number,
    centerScreen?: boolean,
    height?: number | string,
    text?: string
}

export const LoadingSpinner = ({spacing = 20, centerScreen = false, height = 0, text = 'Loading'}: Props) => {
    return (
        <div className={'w-full flex items-center ' + (centerScreen ? 'h-screen' : '')} style={
            height === 0 ? {} : {
                height: height
            }
        }>
            <div className='m-auto flex flex-col items-center'>
                <div className={
                    `loader ease-linear rounded-full border-${8} border-t-${8} border-gray-200 ` +
                    `h-${spacing} w-${spacing}`}/>
                {
                    text && <div className='loading-text pt-2'>{text}</div>
                }
            </div>
        </div>
    );
}
